import React from 'react';

export default function Footer() {
  return (
    <header id="header">
    </header>
  );
}
